module.exports = __webpack_public_path__ + "img/404-1.7651f504.png";